import { Provider } from 'react-redux';
import { store } from 'redux/store';
import * as Sentry from '@sentry/react';
import { SocketProvider } from 'context/SocketContext';
import { ServerTimeProvider } from 'context/ServerTimeContext';
import DevToolsBlocker from 'components/ui/DevToolsBlocker';
import useDisableInspect from './hooks/useDisableInspect';
import Routes from './Routes';

function App() {
  const isOpen = useDisableInspect();

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 1.0,
    sendDefaultPii: false,
  });

  if (isOpen) {
    return <DevToolsBlocker />;
  }

  return (
    <Provider store={store}>
      <ServerTimeProvider>
        <SocketProvider>
          <Routes />
        </SocketProvider>
      </ServerTimeProvider>
    </Provider>
  );
}

export default App;
